// src/utils/confirm.js
import Swal from 'sweetalert2';

export const showConfirm = async ({ title, text, icon = 'warning' } = {}) => {
    const result = await Swal.fire({
        title,
        text,
        icon,
        showCancelButton: true,
        confirmButtonText: '확인',
        cancelButtonText: '취소',
    });
    return result.isConfirmed;
};